import type { PriceQuote } from "@/lib/bookings-api";

/** Shared presentation eligibility. The quote/server still owns financial policy. */
export function eligiblePlatformCoverage(country: string | null | undefined, state: string | null | undefined, value: number | null | undefined, rentalType: string): boolean {
  const region = state?.trim().toUpperCase();
  return country?.trim().toUpperCase() === "US" && rentalType === "driving"
    && !!region && !["NY", "NEW YORK"].includes(region)
    && Number(value) > 0 && Number(value) <= 150000;
}

export function coverageConfirmationContext(carId: number, rentalType: string, country: string | null | undefined, state: string | null | undefined, value: number | null | undefined): string {
  return JSON.stringify([carId, rentalType, country?.trim().toUpperCase(), state?.trim().toUpperCase(), Number(value)]);
}

/**
 * The quote, not the optional alternatives catalogue, confirms coverage.
 * An upstream selection alone (or a previous car's quote) is not proof.
 */
export function hasConfirmedCheckoutInsurance(
  quote: PriceQuote | null,
  context: { carId: number; rentalType: string; dateFrom: string; dateTo: string; selectedInsuranceId: number | null },
): boolean {
  return !!quote
    && quote.carId === context.carId
    && quote.rentalType === context.rentalType
    && quote.dateFrom === context.dateFrom
    && quote.dateTo === context.dateTo
    && context.selectedInsuranceId != null
    && quote.insurancePackageId === context.selectedInsuranceId
    && Number.isFinite(quote.insuranceFee) && quote.insuranceFee > 0
    && Number.isFinite(quote.insuranceDailyRate) && quote.insuranceDailyRate > 0;
}